/* WESN Flagship Weekend — hero film, giveaway carousel, on-the-day tabs. Everything degrades without it:
   the poster shows, the carousel is a native scroll-snap row, the first tab is open. */
(function () {
  'use strict';
  var doc = document;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  /* Hero film: attach the source only when it will play (in view, motion allowed), pause off-screen, resume on return. */
  function film(v) {
    if (v.__fw) return; v.__fw = true;
    var src = v.getAttribute('data-src');
    if (!src || reduced || saveData) return;
    function play() {
      if (!v.getAttribute('src')) { v.setAttribute('src', src); v.load(); }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    function seen() { var r = v.getBoundingClientRect(); return r.bottom > 0 && r.top < (window.innerHeight || doc.documentElement.clientHeight); }
    function onVisible() { if (!doc.hidden && v.paused && seen()) play(); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { if (e[0].isIntersecting) play(); else if (!v.paused) v.pause(); }, { threshold: 0.05 }).observe(v);
    }
    setTimeout(onVisible, 500);
    doc.addEventListener('visibilitychange', onVisible);
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
  }

  /* Carousel: counter, previous/next, mouse drag (touch scrolls natively). */
  function carousel(root) {
    if (root.__fw) return; root.__fw = true;
    var track = root.querySelector('[data-fw-track]'), slides = [].slice.call(root.querySelectorAll('[data-fw-slide]'));
    var count = root.querySelector('[data-fw-count]'), prev = root.querySelector('[data-fw-prev]'), next = root.querySelector('[data-fw-next]');
    if (!track || !slides.length) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function index() {
      var x = track.scrollLeft, best = 0, d = Infinity;
      slides.forEach(function (s, i) { var dd = Math.abs(s.offsetLeft - x); if (dd < d) { d = dd; best = i; } });
      return best;
    }
    function update() {
      var i = index(), end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (count) count.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = end;
    }
    function go(dir) {
      var i = Math.max(0, Math.min(slides.length - 1, index() + dir));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var ticking = false;
    track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { update(); ticking = false; }); } }, { passive: true });
    window.addEventListener('resize', update);
    /* drag with a mouse */
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('mousedown', function (e) { if (e.button !== 0) return; down = true; moved = false; startX = e.pageX; startLeft = track.scrollLeft; });
    doc.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (!moved && Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); }
      if (moved) { e.preventDefault(); track.scrollLeft = startLeft - dx; }
    });
    doc.addEventListener('mouseup', function () {
      if (!down) return; down = false;
      if (moved) { track.classList.remove('is-dragging'); var i = index(); track.scrollTo({ left: slides[i].offsetLeft, behavior: reduced ? 'auto' : 'smooth' }); }
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    update();
  }

  /* Tabs */
  function tabs(root) {
    if (root.__fw) return; root.__fw = true;
    var btns = [].slice.call(root.querySelectorAll('[role="tab"]')), panels = [].slice.call(root.querySelectorAll('[role="tabpanel"]'));
    function select(i) {
      btns.forEach(function (b, j) { var on = j === i; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p, j) { var on = j === i; p.hidden = !on; p.classList.toggle('is-active', on); });
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(i); });
      b.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = (i + 1) % btns.length;
        if (k === 'ArrowLeft' || k === 'ArrowUp') n = (i - 1 + btns.length) % btns.length;
        if (k === 'Home') n = 0; if (k === 'End') n = btns.length - 1;
        if (n !== null) { e.preventDefault(); select(n); btns[n].focus(); }
      });
    });
  }

  function init(scope) {
    scope = scope || doc;
    [].forEach.call(scope.querySelectorAll('[data-fw-film]'), film);
    [].forEach.call(scope.querySelectorAll('[data-fw-carousel]'), carousel);
    [].forEach.call(scope.querySelectorAll('[data-fw-tabs]'), tabs);
  }
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); }); else init();
})();
